import { useState } from 'react';
import { useAgentPermission } from '@entities/user';
import { Button } from '@shared/ui/Button';
import { Hint, SchemeRegistry, Stack } from '@widgets/GeoSchemes';
import { RequestSchemeDialog } from './RequestSchemeDialog';

/**
 * Вкладка «Исполнительные схемы» в ОСНОВА.Инженер: реестр ИС от геодезии (по
 * умолчанию — ждут проверки), проверка и обратная связь, запрос недостающей схемы.
 */
export function PtoExecSchemes() {
  const { can_write } = useAgentPermission('pto');
  const [requesting, setRequesting] = useState(false);

  return (
    <Stack $gap={4}>
      <Hint>
        Схемы готовит ОСНОВА.Геодезист по ГОСТ Р 51872-2024. Здесь — проверка, передача заказчику и
        обратная связь: отклонённая схема возвращается геодезисту с причиной.
      </Hint>
      <SchemeRegistry
        linkBase="/agents/pto/exec-schemes"
        audience="engineer"
        defaultStatus="submitted"
        actions={
          can_write ? (
            <Button type="button" $variant="secondary" onClick={() => setRequesting(true)}>
              Нет схемы — запросить у геодезии
            </Button>
          ) : undefined
        }
        emptyText="Схем с таким статусом нет. Нужна схема, которой нет в реестре, — запросите её у геодезии."
      />
      {requesting && <RequestSchemeDialog onClose={() => setRequesting(false)} />}
    </Stack>
  );
}
